import { combineReducers } from 'redux';
// Import reducers
import table from './events_live_availability_table_reducer';
import form from './events_live_availability_form_reducer';

export default combineReducers({
	table,
	form
});
